import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../layout/core'
import AllWhatsApp from './AllWhatsApp'
import CreateNewWhatsAppBot from './CreateNewWhatsAppBot'
import WhatsAppBotBuilder from './whatsAppBotBuilder'
import InstallBot from '../../components/whatsAppBots/manageBot/InstallBot'

const WhatsAppBots = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/all-bots'
          element={
            <>
              <PageTitle breadcrumbs={[]}>All WhatsApp Bots</PageTitle>
              <AllWhatsApp />
            </>
          }
        />

        <Route
          path='/create-new-whatsapp-bot'
          element={
            <>
              <PageTitle breadcrumbs={[]}>Create New WhatsApp Bot</PageTitle>
              <CreateNewWhatsAppBot />
            </>
          }
        />

        <Route
          path='/bot-builder/:uuid'
          element={
            <>
              <PageTitle breadcrumbs={[]}>WhatsApp Bot Builder</PageTitle>
              <WhatsAppBotBuilder />
            </>
          }
        />

        <Route
          path='/bot-builder/install-bot/:uuid'
          element={
            <>
              <PageTitle breadcrumbs={[]}>Install Bot</PageTitle>
              <InstallBot />
            </>
          }
        />

        <Route index element={<Navigate to='/whatsapp-bots/all-bots' />} />
      </Route>
    </Routes>
  )
}

export default WhatsAppBots
